<table class="table">
  <thead>
    <tr>
      <th (click)="allCheck()">-</th>
      <th *ngFor="let c of colRange" (click)="colCheck(c)">
        {{ colLabels[c] }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of rowRange">
      <th (click)="rowCheck(r)">{{ rowLabels[r] }}</th>
      <td
        *ngFor="let c of colRange"
        (click)="check(r, c)"
        [ngClass]="_value[r][c] ? ['check'] : ['uncheck']"
      ></td>
    </tr>
  </tbody>
</table>
